/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pregnancy-case.reducer';

export const PregnancyCaseDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pregnancyCaseEntity = useAppSelector(state => state.pregnancyCase.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pregnancyCaseDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pregnancyCase.detail.title">PregnancyCase</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.id">Id</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.id}</dd>
          <dt>
            <span id="lmp">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.lmp">Lmp</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.lmp}</dd>
          <dt>
            <span id="expectedDueDate">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.expectedDueDate">Expected Due Date</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.expectedDueDate}</dd>
          <dt>
            <span id="deliveryStatus">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.deliveryStatus">Delivery Status</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.deliveryStatus ? 'true' : 'false'}</dd>
          <dt>
            <span id="pregnancyResult">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.pregnancyResult">Pregnancy Result</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.pregnancyResult}</dd>
          <dt>
            <span id="pregnancySight">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.pregnancySight">Pregnancy Sight</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.pregnancySight}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.active">Active</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pregnancyCase.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pregnancyCaseEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pregnancyCase.event">Event</Translate>
          </dt>
          <dd>{pregnancyCaseEntity.event ? pregnancyCaseEntity.event.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pregnancyCase.patient">Patient</Translate>
          </dt>
          <dd>{pregnancyCaseEntity.patient ? pregnancyCaseEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pregnancy-case" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pregnancy-case/${pregnancyCaseEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PregnancyCaseDetail;
